import React, { useCallback, useEffect, useState } from "react";
import { API } from "../../../shared/api/Api";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserInformations } from "../../../features/authSlice";
import { showToast } from "../../../utils/utils";
import axios from "axios";
import StudentTable from "../../../components/Tables/StudentTable";
import { FiArrowLeft } from "react-icons/fi";

const CourseStudentsPage = () => {
  const [reFetchData, setReFetchData] = useState(false);
  const [students, setStudents] = useState([]);
  const [loader, setLoader] = useState(true);

  const location = useLocation();
  const params = useParams();
  const user = useSelector(selectUserInformations);

  const fetchCourseStudents = useCallback(async () => {
    try {
      const { data } = await axios.get(
        `${API.Courses.app_courses_allStudentsCourse}/${params.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (data.status === 200 && data.errorCode === 0) {
        setStudents(data.data);
      } else {
        showToast("Error", "Failed to fetch courses", "error");
      }
    } catch (error) {
      showToast(
        "Error",
        error.response?.data?.message || "An error occurred",
        "error"
      );
    }
  }, [user.token, params.id]);

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true); // Show loader during fetching
      try {
        setStudents([]);
        await fetchCourseStudents();
      } catch (error) {
        showToast("Error", error || "An error occurred", "error");
      } finally {
        setLoader(false); // Hide loader after fetching is complete
        setReFetchData(false);
      }
    };
    fetchData();
  }, [fetchCourseStudents, reFetchData]);
  const courseName = location.state?.course?.title || "Course";

  return (
    <div className="min-h-screen p-2 sl:pt-0 sm:p-2 md:p-4 sl:p-6">
      {/* Header with Back Navigation */}
      <div className="mb-4 flex items-center gap-4">
        <Link
          to={`/dashboard/courses/${params.id}`}
          className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-700"
        >
          <FiArrowLeft className="w-5 h-5" />
        </Link>
        <div>
          <h1 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white">
            Students in {courseName}
          </h1>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            View and manage enrolled students
          </p>
        </div>
      </div>

      <StudentTable
        students={students}
        currentPage=""
        totalPages=""
        onSearchChange=""
        onPageChange=""
        loader={loader}
        setReFetchData={setReFetchData}
        courseStudents={true}
        courseData={location.state}
      />
    </div>
  );
};

export default CourseStudentsPage;
